import { ElevesView } from '@teetsh/app/src/types/eleves';

export function updateViewWithVisibleFields(
  fieldKey: string,
  visible: boolean,
  view: ElevesView,
) {
  const viewField = view.fields.find(f => f.id === fieldKey);
  if (viewField) {
    viewField.visible = visible;
    return { ...view, fields: view.fields };
  }
  return view;
}
